import { setRoleDeleteModalOpen } from "pages/ManageRoles/roleSlice";
import { useDispatch, useSelector } from "react-redux";
import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function DeleteRole({ selectedData, handleDeleteRole, data }) {
  const dispatch = useDispatch();
  const { roleDeleteModalOpen, roleDeleteLoading } = useSelector(
    (state) => state.roles
  );

  const handleDelete = () => {
    handleDeleteRole(data);
  };

  return (
    <ModalComp
      title="Delete Role"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => dispatch(setRoleDeleteModalOpen(false))}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={roleDeleteLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="danger"
          secondaryBtnText="Delete"
        />
      }
      open={roleDeleteModalOpen}
      setOpen={(Value) => dispatch(setRoleDeleteModalOpen(Value))}
    >
      {`Are you sure you want to delete the role named '${selectedData?.role_name}'`}
    </ModalComp>
  );
}

export default DeleteRole;
